import script from "./AppDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AppDialog.vue?vue&type=script&setup=true&lang=js"

import "./AppDialog.vue?vue&type=style&index=0&id=390077b8&lang=scss&scoped=true"
import "./AppDialog.vue?vue&type=style&index=1&id=390077b8&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-390077b8"]])

export default __exports__